/**
 * FREE GIFTS PROGRESS DISPLAY
 * 
 * This script handles the UI display for free gift progress indicators:
 * - Renders circular progress icons around qualifying gift items
 * - Updates progress bars based on cart value
 * - Shows how close the customer is to each gift tier
 * - Uses ORIGINAL prices (before discounts) to maintain tier eligibility
 * 
 * Note: Gift adding/removing is handled elsewhere - this is display only.
 */

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const refreshCartItems = (response) => {
  return new Promise(async (resolve, reject) => {
    const cartHTML = new DOMParser()
      .parseFromString(response.sections['cart-drawer'], 'text/html')
      .querySelector('cart-drawer-items');

    document.querySelector('cart-drawer-items').innerHTML = cartHTML.innerHTML;

    // Delete Notification if present
    if (document.querySelector('.free-gifts-modal')) {
      document.querySelector('.free-gifts-modal').remove();
    }
    resolve();
  });
};

const updateCartButton = () => {
  fetch('/cart.js', {
    method: 'GET'
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      const items = json.items.filter(i => i.properties['shipping_interval_frequency']);
      if (items.length) {
        document.querySelector('[data-sub-cart]').classList.add('active');
      } else {
        document.querySelector('[data-no-sub-cart]').classList.add('active');
      }
    })
    .catch(function (err) {
      console.error(err);
    });
};

/* This is the Free Gifts Bubble Rendering */
window.reRenderGifts = () => {
  console.log('re rendering gifts');

  function gtag_report_conversion(url) {
    var callback = function () {
      if (typeof url != 'undefined') {
        window.location = url;
      }
    };
    gtag('event', 'conversion', {
      send_to: 'AW-739947719/T8T9CPaN-44bEMfp6uAC',
      event_callback: callback
    });
    return false;
  }

  gtag_report_conversion();

  return new Promise((resolve, reject) => {
    const freeGiftWraps = document.querySelectorAll('.free-gifts-progress-bar__wrap');

    [...freeGiftWraps].forEach(wrap => {
      // Clear Existing
      wrap.innerHTML = '';

      for (let i = 0; i < window.freegifts.products.length; i++) {
        const currentGift = window.freegifts.products[i];

        const currentProduct = `
          <div data-free-gift data-free-gift-price="${currentGift.productPrice}">
            <div class="free-gifts-progress-bar__item" style="--value:0">
              <img src="${currentGift.product}"
                class="free-gifts-progress-bar__img" loading="lazy" />
            </div>
            <div class="free-gifts-progress-bar__text-wrap">
              <span class="free-gifts-progress-bar__text">${currentGift.titleOverride}</span>
              <span class="free-gifts-progress-bar__price">$${currentGift.productPrice}</span>
            </div>
          </div>`;

        wrap.insertAdjacentHTML('beforeend', currentProduct);
      }
    });
    resolve();
  });
};

reRenderGifts();

let cartValue = 0;

// Function to calculate cart total excluding free gifts, using ORIGINAL prices before discounts
// This prevents discounted items from dropping the cart below tier thresholds
const calculateCartTotalExcludingGifts = (cartData) => {
  const nonGiftItems = cartData.items.filter(item => {
    // Check if this item is a free gift by comparing with gift tiers
    return !window.freegifts.products.some(gift =>
      gift.tier &&
      gift.tier.some(tier =>
        tier.variants &&
        tier.variants.some(variant =>
          variant.id === item.variant_id || variant.id === item.id
        )
      )
    );
  });

  // Calculate total using ORIGINAL prices (before any discounts)
  return nonGiftItems.reduce((total, item) => {
    const originalPrice = item.original_line_price || item.line_price || item.price * item.quantity;
    return total + originalPrice;
  }, 0) / 100;
};

// Function to calculate cart total INCLUDING all items (for display purposes)
const calculateCartTotalIncludingGiftsPreDiscount = (cartData) => {
  return cartData.items.reduce((total, item) => {
    // Use original prices before any discounts are applied
    const originalPrice = item.original_line_price || item.line_price || item.price * item.quantity;
    return total + originalPrice;
  }, 0) / 100;
};

// Function to identify items that have been discounted to $0 (like Product X)
const getDiscountedToZeroItems = (cartData) => {
  return cartData.items.filter(item => {
    const currentPrice = item.final_line_price || item.line_price || 0;
    const originalPrice = item.original_line_price || item.line_price || item.price * item.quantity;

    // Item is discounted to $0 if original price > 0 but current price is 0
    return originalPrice > 0 && currentPrice === 0;
  });
};

// Function to check if cart contains a gift card
const hasGiftCardInCart = (cart) => {
  //return cart.items.some(item => item.gift_card === true);
  return false;
};

window.addEventListener('atc', async () => {
  await reRenderGifts();
  renderCurrentState();
});

const addToCartEvent = new Event('add-to-cart');
window.addEventListener('add-to-cart', async () => {
  await reRenderGifts();
  renderCurrentState();
}, false);

const updateProgressValue = new Event('notify-progress');

// Main render function - updates progress indicators based on cart value
window.renderCurrentState = async () => {
  const free_gifts = document.querySelectorAll('#free-gift-bubbles');

  await fetch('/cart.js')
    .then(response => response.json())
    .then(async data => {
      // Hide gifts display if gift card in cart
      if (hasGiftCardInCart(data)) {
        [...free_gifts].forEach(parent_gift => {
          parent_gift.style.display = 'none';
        });
        return;
      }

      // Use the calculation that excludes free gifts and uses pre-discount prices
      cartValue = calculateCartTotalExcludingGifts(data);
      const totalIncludingGiftsPreDiscount = calculateCartTotalIncludingGiftsPreDiscount(data);
      const currentSubtotal = data.items_subtotal_price / 100;

      // Check for items discounted to $0 (like Product X scenario)
      const discountedToZeroItems = getDiscountedToZeroItems(data);

      console.log('Cart Totals:');
      console.log('- Pre-discount total (excluding gifts):', cartValue);
      console.log('- Pre-discount total (including gifts):', totalIncludingGiftsPreDiscount);
      console.log('- Current subtotal (after discounts):', currentSubtotal);
      console.log('- Difference from discounts:', (totalIncludingGiftsPreDiscount - currentSubtotal).toFixed(2));

      if (discountedToZeroItems.length > 0) {
        console.log('Items discounted to $0:');
        discountedToZeroItems.forEach(item => {
          const originalPrice = item.original_line_price || item.line_price || item.price * item.quantity;
          console.log(`- ${item.product_title}: $${(originalPrice / 100).toFixed(2)} → $0.00`);
        });
      }

      // Update progress bars and UI
      [...free_gifts].forEach(async (parent_gift, index) => {
        let active = true;
        let moreFreeGifts = parent_gift.querySelectorAll('[data-free-gift]');

        [...moreFreeGifts].forEach(async (gift, giftIndex) => {
          const currentGiftPrice = parseInt(gift.dataset.freeGiftPrice);
          // Use consistent cart value calculation (excluding gifts)
          cartValue = calculateCartTotalExcludingGifts(data);

          gift.querySelector('.free-gifts-progress-bar__item').classList.remove('finished');

          const passValueToProgressBar = (cartValue, currentGiftPrice, currentGiftIndex) => {
            const updateProg = new CustomEvent('notify-progress', {
              detail: {
                cartValue,
                currentGiftPrice,
                currentGiftIndex
              }
            });
            document.dispatchEvent(updateProg);
          };

          if (active) {
            switch (cartValue >= currentGiftPrice) {
              case true:
                // Gift tier reached - show full progress
                gift.querySelector('.free-gifts-progress-bar__item').style.animation = 'none';
                gift.querySelector('.free-gifts-progress-bar__item').offsetHeight;
                gift.querySelector('.free-gifts-progress-bar__item').style.animation = null;
                gift.querySelector('.free-gifts-progress-bar__item').style.setProperty('--value', 100);
                gift.querySelector('.free-gifts-progress-bar__item').classList.add('finished');
                break;
              case false:
                // Gift tier not reached - show partial progress
                const percentageValue = parseFloat(((cartValue / currentGiftPrice) * 100).toFixed(2));
                gift.querySelector('.free-gifts-progress-bar__item').style.animation = 'none';
                gift.querySelector('.free-gifts-progress-bar__item').offsetHeight;
                gift.querySelector('.free-gifts-progress-bar__item').style.animation = null;
                gift.querySelector('.free-gifts-progress-bar__item').style.setProperty('--value', percentageValue);
                parent_gift.querySelector('[data-away-from]').innerHTML = `$${Math.abs(cartValue - currentGiftPrice).toFixed(2)}`;
                active = false;
                passValueToProgressBar(cartValue, currentGiftPrice, giftIndex);
              default:
                break;
            }
          }
        });
      });

      // Update bar text based on whether all gifts are unlocked
      if (cartValue >= freegifts.products[freegifts.products.length - 1].productPrice) {
        allFreeGiftsApplied();
      } else {
        revertBarText();
      }
    });
};

renderCurrentState();

/* Progress bar event handling */
document.addEventListener('notify-progress', event => {
  const { cartValue, currentGiftPrice, currentGiftIndex } = event.detail;
  showProgress(cartValue, currentGiftPrice, currentGiftIndex);
});

const passValuesToBars = (amountLeft, currentGiftIndex) => {
  const allProgressBars = document.querySelectorAll('[data-progress-bar]');
  const currentProductTitle = window.freegifts.products[currentGiftIndex].titleOverride;

  allProgressBars.forEach(bar => {
    bar.querySelector('[data-progress-value').innerText = amountLeft.toFixed(2);
    bar.querySelector('[data-progress-gift-title]').innerText = currentProductTitle;
  });
};

/* Progress calculation and display */
const showProgress = (cartValue, currentGiftPrice, currentGiftIndex) => {
  const valueToPercent = Math.abs(cartValue - currentGiftPrice);
  passValuesToBars(valueToPercent, currentGiftIndex);
  const grow = document.querySelectorAll('.grow');
  grow.forEach(g => {
    g.style.width = 100 - (valueToPercent / currentGiftPrice) * 100 + '%';
  });
};

const allFreeGiftsApplied = () => {
  const allProgressBars = document.querySelectorAll('.prog-width');
  allProgressBars.forEach(el => {
    el.querySelector('[data-progress-finished]').classList.add('active');
    el.querySelector('[data-progress-bar]').classList.add('hidden');
  });
};

const revertBarText = () => {
  const allProgressBars = document.querySelectorAll('.prog-width');
  allProgressBars.forEach(el => {
    el.querySelector('[data-progress-finished]').classList.remove('active');
    el.querySelector('[data-progress-bar]').classList.remove('hidden');
  });
};